import { render, staticRenderFns } from "./TgjuPosts.vue?vue&type=template&id=76a89417&"
import script from "./TgjuPosts.vue?vue&type=script&lang=js&"
export * from "./TgjuPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports